export const APP_NAME = 'HalfNote';
export const APP_KEY = 'halfnote';

// Redirect Paths
export const REDIRECT_URL_KEY = 'redirect';
export const HOME_PATH = '/';
export const GHOST_ENTRY_PATH = '/callback';
